<template>
  <nav
    v-if="position === 'side' || position === 'simple'"
    :class="[
      'hidden md:block overflow-x-hidden',
      {
        'pr-5 pt-14 pb-16  w-[85px] xl:w-[230px]':
          layout === 'rubick' && position === 'side',
        'pr-5 pt-14 pb-16  w-[85px]':
          layout === 'rubick' && position === 'simple',
      },
      {
        'w-[105px] xl:w-[260px] pt-[110px] px-5 pb-16  z-50':
          layout === 'enigma' && position === 'side',
        'w-[105px] px-5 pb-16 pt-[110px] z-50':
          layout === 'enigma' && position === 'simple',
      },
      {
        'w-[105px] xl:w-[250px] px-5 pt-8 pb-16 ':
          layout === 'icewall' && position === 'side',
        'w-[105px] px-5 pt-8 pb-16 ':
          layout === 'icewall' && position === 'simple',
      },
      {
        'md:w-[105px] xl:w-[250px] pt-14 px-5 pb-16 z-1':
          layout === 'tinker' && position === 'side',
        'md:w-[105px] xl:w-[105px] pt-14 px-5 pb-16 z-10':
          layout === 'tinker' && position === 'simple',
      },
    ]"
  >
    <ul>
      <SideMenuComponent
        v-for="(menu, index) in formattedMenu"
        :key="index"
        :menuIndex="index"
        :menu="menu"
        :isRoot="true"
        :layout="layout"
        :position="position"
      >
      </SideMenuComponent>
    </ul>
  </nav>
  <nav
    v-if="position === 'top'"
    :class="[
      'z-[51] hidden md:block',
      {
        'relative': layout === 'rubick',
      },
      {
        'relative pt-16 -mt-4': layout === 'enigma',
        // Animation
        'opacity-0 animate-[0.4s_ease-in-out_0.2s_intro-top-menu] animate-fill-mode-forwards':
          layout === 'enigma',
      },
      {
        'md:px-6 -mt-2 xl:-mt-[3px]': layout === 'icewall',
        'animate-[0.4s_ease-in-out_0.3s_intro-top-menu] animate-fill-mode-forwards opacity-0 translate-y-[35px]':
          layout === 'icewall',
        relative: position !== 'top' && layout === 'icewall',
        'absolute pt-[67px]': position === 'top' && layout === 'icewall',
      },
      {
        'relative py-5': layout === 'tinker',
        'translate-y-[50px] opacity-0 animate-[0.4s_ease-in-out_0.2s_intro-top-menu] animate-fill-mode-forwards':
          layout === 'tinker',
      },
    ]"
  >
    <ul
      :class="[
        {
          'pb-3 xl:pb-0 xl:px-[50px] flex flex-wrap': layout === 'rubick',
        },
        {
          'flex flex-wrap px-6 xl:px-[50px]': layout === 'enigma',
        },
        {
          'h-[50px] flex flex-wrap': layout === 'icewall',
        },
        {
          'flex flex-wrap h-[58px] px-6 xl:px-[50px]': layout === 'tinker',
        },
      ]"
    >
      <TopMenuComponent
        v-for="(menu, index) in formattedMenu"
        :key="index"
        :menuIndex="index"
        :menu="menu"
        :isRoot="true"
        :layout="layout"
      >
      </TopMenuComponent>
    </ul>
  </nav>
  <!-- END: Main menu -->
</template>

<script setup lang="ts">
import { ref, watch, computed, defineProps, onMounted } from "vue";
import Divider from "./Divider.vue";
import SideMenuComponent from "./SideMenuComponent.vue";
import TopMenuComponent from "./TopMenuComponent.vue";
import { nestedMenu } from "./main-menu";
import { useRoute } from "vue-router";
import { useStore } from "vuex";

const formattedMenu = ref([]);

const route = useRoute();
const store = useStore();

const props = defineProps({
  position: String,
  layout: String,
});

onMounted(() => {
  formattedMenu.value = nestedMenu(store.getters.getMenu, route);
});

watch(
  () => route.path,
  () => {
    formattedMenu.value = nestedMenu(store.state.menu, route);
  }
);

// TODO remove delay from menu change
watch(
  () => store.state.menu,
  () => {
    formattedMenu.value = nestedMenu(store.state.menu, route);
  }
);
</script>
